import React from 'react';
import {Link} from 'react-router-dom';
import {AdminConversion} from '../../domain/admin';
import {ConversionTable} from './AdminUserActivity';
import {EmptyState, Panel} from './AdminPrimitives';
import {ArrowRightIcon} from '../Icons';

/**
 * The user detail page's non-paginated echo of the full conversion history — up to 20, newest
 * first, fetched alongside the rest of the profile in `GET /admin/users/:id` rather than a second
 * round trip. Reuses `ConversionTable` so the per-row detail (media reference, editor snapshot,
 * fps, beep sound) has one implementation instead of two that could drift apart.
 *
 * The full paged history lives at its own route, `/admin/users/:userId/conversions`
 * (`adminUserConversions.container.tsx`) — the same reason the global transcription queue is a
 * page of its own rather than a tab. This panel is the preview; "View all" is the way there.
 */
interface AdminRecentConversionsProps {
  userId: string;
  conversions: AdminConversion[];
}

const AdminRecentConversions: React.FC<AdminRecentConversionsProps> = ({userId, conversions}) => (
  <Panel
    padded={false}
    title="Recent conversions"
    subtitle="Up to 20, newest first."
    actions={
      <Link
        to={`/admin/users/${userId}/conversions`}
        className="inline-flex items-center gap-1 text-[11px] font-medium text-indigo-400
         hover:text-indigo-300"
      >
        View all
        <ArrowRightIcon className="h-3 w-3" />
      </Link>
    }
  >
    {conversions.length === 0 ? (
      <EmptyState message="No conversions yet." />
    ) : (
      <div className="overflow-x-auto">
        <ConversionTable rows={conversions} />
      </div>
    )}
  </Panel>
);

export default AdminRecentConversions;
